module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fYkwG"))).then(() => parcelRequire('1iHdE'));